// Admin Blocks
import './admin-blocks/twrpb-hidden/twrpb-hidden';
import './admin-blocks/twrpb-collapsible/twrpb-collapsible';
import './admin-blocks/twrpb-docs/twrpb-docs';

// General Settings
import './general-settings/twrpb-general-settings';

// Query Settings
import './query-settings/twrpb-advanced-settings/twrpb-advanced-settings';
import './query-settings/twrpb-author-settings/twrpb-author-settings';
import './query-settings/twrpb-cat-settings/twrpb-cat-settings';
import './query-settings/twrpb-comments-settings/twrpb-comments-settings';
import './query-settings/twrpb-date-settings/twrpb-date-settings';
import './query-settings/twrpb-meta-setting/twrpb-meta-setting';
import './query-settings/twrpb-order-setting/twrpb-order-setting';
import './query-settings/twrpb-posts-settings/twrpb-posts-settings';
import './query-settings/twrpb-query-settings/twrpb-query-settings';
import './query-settings/twrpb-query-templates/twrpb-query-templates';
import './query-settings/twrpb-search-setting/twrpb-search-setting';
import './query-settings/twrpb-statuses-settings/twrpb-statuses-settings';

// Widget Blocks
import './widget-blocks/twrpb-widget-form';
import './widget-blocks/twrpb-meta-tooltip';
import './widget-blocks/twrpb-widget-components';
import './widget-blocks/twrpb-sync-widget-query-settings';
import './widget-blocks/twrpb-color-picker';

export default {};
